import React from "react";
import { Box, TextField, Button, Stack, IconButton, InputAdornment } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const BuscarVehiculo = ({ valor, setValor, handleBuscar, cargando }) => {
  const onSubmit = (e) => {
    e.preventDefault();
    if (!cargando && valor.trim()) handleBuscar();
  };

  return (
    <Box component="form" onSubmit={onSubmit} autoComplete="off">
      <Stack direction="row" spacing={1} alignItems="center">
        <TextField
          label="Buscar vehículo"
          variant="outlined"
          size="small"
          value={valor}
          onChange={(e) => setValor(e.target.value)}
          placeholder="Ingrese placa, UID, etc."
          disabled={cargando}
          autoFocus
          slotProps={{
            input: {
              endAdornment: valor && !cargando ? (
                <InputAdornment position="end">
                  <IconButton size="small" edge="end" aria-label="Borrar búsqueda" onClick={() => setValor("")} sx={{ p: 0.25 }}>
                    <CloseIcon sx={{ fontSize: 15 }} />
                  </IconButton>
                </InputAdornment>
              ) : null,
            },
          }}
          sx={{
            width: 260,
            "& .MuiInputBase-root": { height: 32 },
            "& .MuiInputBase-input": { fontSize: "0.78rem", py: 0.5 },
            "& .MuiInputLabel-root": { fontSize: "0.78rem" },
          }}
        />
        <Button
          variant="contained"
          color="primary"
          type="submit" // ⬅️ Enter dispara submit
          disabled={cargando || !valor.trim()}
          size="small"
          sx={{ height: 32, fontSize: "0.75rem", px: 1.5 }}
        >
          {cargando ? "Buscando..." : "Buscar"}
        </Button>
      </Stack>
    </Box>
  );
};

export default BuscarVehiculo;
